
import { useRoutes } from "react-router-dom";
import './App.css';
import Login from "./pages/Login/Login";
import PlayVideoWrapper from "./pages/PlayVideo/PlayVideoWrapper";


// type ForwardRefType = {
//   isVideoPlaying: boolean
//   handleVideoPlay(flag: string): void
//   singleSentencePatternChangedHandle(bool: boolean): void
//   showModal(): void
//   subHidenType: {
//     text0Show: boolean
//     text1Show: boolean
//     type: string
//   }
//   videoTimeLine: number
// }

function App() {
  const routes = useRoutes([
    { path: "/", element: <PlayVideoWrapper /> },
    // { path: "/video", element: <PlayVideoWrapper /> },
    {
      // path: "/",
      path: "/login",
      element: <Login />,
      children: [],
    },
  ]);
  return (
    <div className="App">
      {routes}
    </div>
  );
}

export default App;
